"use client";

import dynamic from "next/dynamic";

const STS = dynamic(() => import("./STS"));

export default STS;
